import { useRef } from 'react';

/**
 * Returns true once zoom has settled beyond rest scale, so the zoomed image can be upgraded
 * to its highest available quality.
 *
 * The result latches on per element, so zooming back out never swaps an already-loaded
 * high quality image for a lower quality one.
 */
export const useImageModalHasZoomedIn = ({
    elementId,
    settledScale,
}: {
    elementId: string;
    settledScale: number;
}): boolean => {
    const hasZoomedInRef = useRef(false);
    const elementIdRef = useRef(elementId);

    if (elementIdRef.current !== elementId) {
        elementIdRef.current = elementId;
        hasZoomedInRef.current = false;
    }

    if (settledScale > 1) {
        hasZoomedInRef.current = true;
    }

    return hasZoomedInRef.current;
};
